import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent,LoginEmailComponent, SignupComponent } from './auth.component';
import { OAuthComponent } from './oauth.component';
import { SharedModule } from '../commons/shared.module';
import { AppRoutes } from '../commons/global';
import { ActivateComponent } from './activate.component';
import { ForgetComponent } from './forget.component';

const AppRouting: Routes = [
 
    { path: '', component:AuthComponent, pathMatch: 'full'},
    { path: 'forget/:tok', component:ForgetComponent, pathMatch: 'full' },
   
    { path: AppRoutes.EMAIL, component:LoginEmailComponent, pathMatch: 'full' },
    { path: AppRoutes.SIGNUP, component:SignupComponent, pathMatch: 'full' },
    { path: AppRoutes.ACTIVATE_ACC, component:ActivateComponent, pathMatch: 'full' },
    { path: AppRoutes.ACTIVATE_ACC_GRP, component:ActivateComponent, pathMatch: 'full' },
    { path: AppRoutes.ACTIVATE_NO_ACC, component:ActivateComponent, pathMatch: 'full' },
    { path: AppRoutes.OAUTH, component:OAuthComponent, pathMatch: 'full' },
    { path: 'share/:token/:secret', component:OAuthComponent, pathMatch: 'full'},
    { path: AppRoutes.MSG, component:AuthComponent, pathMatch: 'full' }
    
 
];

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedModule,
        RouterModule.forChild(AppRouting)
    ],

    declarations: [
        AuthComponent,
        SignupComponent,
        ForgetComponent,
        OAuthComponent,
        LoginEmailComponent,
        ActivateComponent
    ]
})

export class AuthModule {
   
   
}
